import type { SpaceItem } from '@/types'

/** 按个人空间 / 工作空间分组，供 SpaceSwitcher 渲染 */
export function partitionSpacesByType(spaces: SpaceItem[]): {
  personal: SpaceItem[]
  workspace: SpaceItem[]
} {
  const personal: SpaceItem[] = []
  const workspace: SpaceItem[] = []
  for (const space of spaces) {
    if (space.type === 'personal') personal.push(space)
    else workspace.push(space)
  }
  return { personal, workspace }
}

/** 入口带入未知 space_id 时，补一条可展示的占位空间 */
export function ensureSpaceInList(
  spaces: SpaceItem[],
  space_id: string,
): SpaceItem[] {
  if (spaces.some((s) => s.id === space_id)) return spaces
  return [
    ...spaces,
    {
      id: space_id,
      name: space_id,
      type: 'workspace',
    },
  ]
}

export function findSpaceById(
  spaces: SpaceItem[],
  space_id: string | null,
): SpaceItem | undefined {
  if (!space_id) return undefined
  return spaces.find((s) => s.id === space_id)
}
